import { render, staticRenderFns } from "./SubItemTable.vue?vue&type=template&id=1c029ac6"
import script from "./SubItemTable.vue?vue&type=script&lang=js"
export * from "./SubItemTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTd})
